import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import heatmap from 'highcharts/modules/heatmap'; // heatmap 모듈 로드
heatmap(Hightcharts); // Highcharts에 heatmap 모듈 등록

const ChartHeat = ({chartData, title}) => {
	if (chartData === undefined || chartData.length === 0) {
		return false;
	}

	const optionsBar = {
		chart: {
			type: 'heatmap',
		},
		title: {
			text: title,
			style : {
				color : '#000',
				fontSize : '14px',
				fontWeight : 'bold'
			}
		},
		xAxis: {
			categories: chartData[0]
		},
		yAxis: {
			categories: chartData[0],
			title: null,
			reversed: true
		},
		colorAxis: {
			min: 0,
			max:1 ,
			minColor: '#FFFFFF',
			maxColor: '#f45b5b'
		},
		series: [{
			name: '유동인구/매출 상관관계',
			borderWidth: 1,
			data: chartData[1],
			dataLabels: {
				enabled: true,
				color: '#000000',
			}
		}],
		legend: {
			enabled: false // 항목 이름 제거 
		}
	};

	return (
		<>
			<HighchartsReact highcharts={Hightcharts} options={optionsBar} containerProps={{ style: {width:'100%' , height: "90%" }}} /> 
		</>
	);
};

export default ChartHeat;